var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"padding":"10px"}},[_c('fx-datagrid-vuetify',{attrs:{"titre":"Factures","url-ressource-end-point":_vm.urlRessourceEndPoint},on:{"ouvrir_facture":_vm.afficher_pdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }